export default __webpack_public_path__ + "resources/icons/d221-6ef5.png";